import React from "react";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/lazy";
import "swiper/css/navigation";

import AOS from 'aos';
import 'aos/dist/aos.css';

import './Projects.scss'

import Project1 from './../images/RamenHouse.png'
import Project2 from './../images/Galaxy.png'
import Appco1 from './../images/Appco-1.png'
import GitHubIcon from '@mui/icons-material/GitHub';


import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import Marquee from "react-fast-marquee";

// import required modules
import { Lazy, Autoplay, Navigation } from "swiper";

import laptop from './../images/laptop.png'
import overview from './../images/shelflab/overview.png'
import logo from './../images/shelflab/logobg.png';
import shelflabBgBlurLeft from './../images/shelflab/shelflab-bg-blur-left.png';
import shelflabBgBlurRight from './../images/shelflab/shelflab-bg-blur-right.png';
import shelflabLaptop from './../images/shelflab/shelflab-laptop.png';
import shelflabTablet from './../images/shelflab/shelflab-tablet.png';

import dyarioLaptop from './../images/dyario/dyario-laptop.png';
import dyarioBgBlurRight from './../images/dyario/dyario-bg-blur-right.png';

AOS.init();


const MainProjects = () => {
  return (
    <>
      <div className="shelflab-layer">
        <div className="shelflab row">
          <div className="project-left order-2
          col-lg-5 order-lg-1 
          col-md-12 
          col-sm-12 
          col-xs-12">
            {/* 
            <svg id="shelflab-bg-blur" viewBox="0 0 700 700" width="600" height="600" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1"><g transform="translate(513.5482898025913 310.19523124255744)"><path d="M134.5 -193.8C161.3 -165.7 160.9 -108.9 180.4 -56.8C199.9 -4.6 239.3 43 244.4 95.5C249.4 148 220.2 205.5 173.8 221.7C127.4 238 63.7 213 -5 219.9C-73.7 226.7 -147.3 265.5 -194.7 249.5C-242.1 233.6 -263.2 163 -297.7 89.1C-332.2 15.2 -380.1 -61.9 -370.9 -129.9C-361.7 -197.9 -295.5 -256.7 -224.2 -270.4C-152.8 -284 -76.4 -252.5 -11.3 -237C53.9 -221.5 107.8 -222 134.5 -193.8" fill="#18c5a0"></path></g></svg> */}
            <img src={shelflabBgBlurLeft} alt="Shelflab" id="shelflab-bg-blur-left" />


            <img class="shelflab-logo" src={logo} alt="Shelflab" width={200} />
            <div className="project-description">
              <h4 className="breaker">Capstone Project
              </h4>
              <h6 className="sub-breaker">Lead Programmer</h6>
              <h6 className="sub-breaker">Flask, Jinja2, PostgreSQL, HTML/CSS, JavaScript</h6>

              {/* <span>Lead Programmer</span> */}
              <p>A business tool specifically for micro-scaled retail enterprise owners that help businesses with limited knowledge of business management and analytics.</p>
              <p>Shelf Lab utilized machine learning models to forecast predictive data which aims to prepare the business for future economic situations</p>
              {/* https://codepen.io/Ketan1333/pen/wQQWay */}
            </div>
            {/* <div className="laptop-div">
          <img src={laptop} alt="laptop" width={700} />

          <img src={overview} className="laptop-screen" alt="Shelflab" width={500} />
        </div> */}
          </div>

          <div className="project-right order-1
          col-lg-7 order-lg-2 
          col-md-12 
          col-sm-12 
          col-xs-12 ">
            <img src={shelflabBgBlurRight} alt="Shelflab" id="shelflab-bg-blur-right" />
            {/* mockuphone */}
            {/* <div class="computer"> */}
            <img id="shelflab-laptop" src={shelflabLaptop} alt="MacBook Computer Apple" />
            {/* <img id="shelflab-laptop" src="https://www.bebold.ch/img/home/macbook-white.png" alt="MacBook Computer Apple" /> */}
            {/* <img id="laptop-screen" src={overview} alt="Shelflab Overview" /> */}
            {/* <div id="laptop-screen"></div> */}
            <img id="shelflab-tablet" src={shelflabTablet} alt="iPad Pro" />

            {/* </div> */}
          </div>
        </div>
      </div>



      <div className="dyario-layer">
        <div className="dyario row">
          <div className="project-left order-2
          col-lg-5 order-lg-1 
          col-md-12 
          col-sm-12 
          col-xs-12">
            <p className="dyario-logo">Dyar.io</p>
            <div className="project-description">
              <h6 className="sub-breaker">
                React JS, HTML/Sass, JavaScript, News API
              </h6>
              <p>
                A web application that provides news, and articles in the Philippines. It is a news aggregator that collects data from different news sources and displays them in one place.
              </p>
              <p>It provides from top to latest news from different categories such as business, entertainment, health, science, sports, technology, and general news.</p>
            </div>
          </div>

          <div className="project-right order-1
          col-lg-7 order-lg-2 
          col-md-12 
          col-sm-12 
          col-xs-12 ">

            <img src={dyarioBgBlurRight} alt="Dyar.io" id="dyario-bg-blur-right" />
            <img id="dyario-laptop" src={dyarioLaptop} alt="MacBook Computer Apple" />
          </div>
        </div >
      </div >
    </>
  );
}


export default function Projects() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal-box">
          <Swiper
            style={{
              "--swiper-navigation-color": "#fff",
            }}
            lazy={true}
            spaceBetween={30}
            centeredSlides={true}
            loop={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            navigation={true}
            modules={[Lazy, Autoplay, Navigation]}
            className="mySwiper"
          >
            <SwiperSlide>
              <img src={Project1} alt="Ramen House" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={Project2} alt="Ramen House" />
            </SwiperSlide>
          </Swiper>

          <div className="used float-start">
            <div>React JS</div>
          </div>
          <a target="_blank" href="https://github.com/meelvore/works-archive" className="view-code float-end">
            <GitHubIcon />
            View Code
          </a>
        </Box>
      </Modal >

      <div className='project-page'>

        <div data-aos="fade-up">
          <div className="section-title-div">
            <h3 className='div-title'><span>R</span>ECENT WORKS</h3>
            <div className="div-centered-text">
              College Activities
            </div>
          </div>
        </div>

        <div className="pre-marquee">
          <Marquee className="marquee" gradientColor={[0, 0, 0]} gradientWidth={'17vw'} speed={40}>
            <img className="projects swiper-lazy" src={Project1} onClick={handleOpen} alt="Ramen House" />
            <img className="projects swiper-lazy" src={Project2} onClick={handleOpen} alt="Galaxy" />
            <img className="projects swiper-lazy" src={Appco1} onClick={handleOpen} alt="Appco" />

          </Marquee>
        </div>

        {/* <div className="layers content">
        <h4 className="breaker">Side Projects</h4>
        <h5>Sarcasn't</h5>
        <span>lorem ipsum</span>
      </div> */}


        <MainProjects />


      </div>
    </>
  );
}